// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"853":"91fdb3ad","1048":"007b783e","2081":"cea99a3a","2565":"1f7b4468","3459":"0f01a8b0","5952":"d6edf49c","9303":"a43da1b6"}[chunkId] + ".chunk.css";
};